//  Reusable scope groups
const baseScopes = ['dashboard', 'style', 'item', 'report'];
const extendedScopes = ['style/workflow', 'storybook', 'test'];
const fullCommonScopes = [...baseScopes, ...extendedScopes];

const supplierScopes = ['suppliers', 'purchase-order', 'supplier', 'direct-suppliers'];
const adminScopes = [...fullCommonScopes, 'admin'];
const marketingScopes = [...fullCommonScopes, 'marketing'];
const orderScopes = [...fullCommonScopes, 'order'];
const analyticsScopes = [...fullCommonScopes, 'analytics'];
const complianceScopes = [...fullCommonScopes, 'compliance', ...supplierScopes];
const complianceAdminScopes = [...adminScopes, 'compliance', ...supplierScopes];
const personalSettingsScope = ['personal-settings'];

const publicScope = ['login', 'supplier/signup', 'supplier/verify'];
const exampleScope = ['example'];

//  Helper: uniform read/write access
const access = (scopes: string[]) => [
  { verb: 'read', scopes },
  { verb: 'write', scopes },
];

// Helper: read/write with different scopes
const mixedAccess = (readScopes: string[], writeScopes: string[]) => [
  { verb: 'read', scopes: readScopes },
  { verb: 'write', scopes: writeScopes },
];

// Roles Definition
export const roles = [
  { role: 'anonymous', access: access([...publicScope]) },
  {
    role: 'Company User',
    access: access([
      'taskboard',
      ...baseScopes,
      ...publicScope,
      ...personalSettingsScope,
      ...exampleScope,
    ]),
  },
  {
    role: 'Company Admin',
    access: access([
      'taskboard',
      ...adminScopes,
      ...publicScope,
      ...personalSettingsScope,
      ...exampleScope,
      ...supplierScopes,
    ]),
  },
  {
    role: 'Test User',
    access: mixedAccess(
      ['taskboard', 'dashboard', 'style/workflow', 'storybook', 'supplier', 'test', ...publicScope],
      [...publicScope]
    ),
  },
  {
    role: 'Test Admin',
    access: access([
      'admin',
      ...fullCommonScopes,
      'style/workflow',
      ...publicScope,
      'suppliers',
      'purchase-order',
      'supplier',
    ]),
  },
  {
    role: 'Supplier Admin',
    access: mixedAccess(
      ['storybook', 'test', ...supplierScopes, ...personalSettingsScope],
      [...supplierScopes, ...personalSettingsScope]
    ),
  },
  {
    role: 'Supplier User',
    access: mixedAccess(
      ['storybook', 'test', ...supplierScopes, ...personalSettingsScope],
      [...supplierScopes, ...personalSettingsScope]
    ),
  },
  {
    role: 'Price',
    access: access([...fullCommonScopes, 'style/workflow']),
  },
  {
    role: 'Analytics',
    access: access([...analyticsScopes]),
  },
  {
    role: 'Batch Modifications',
    access: access([...fullCommonScopes, 'style/workflow']),
  },
  {
    role: 'Care Instructions',
    access: access([...fullCommonScopes, 'style/workflow']),
  },
  {
    role: 'Color Admin',
    access: access([...adminScopes, 'style/workflow']),
  },
  {
    role: 'Compliance Admin',
    access: access([...complianceAdminScopes]),
  },
  {
    role: 'Compliance User',
    access: access([...complianceScopes]),
  },
  {
    role: 'Integrator',
    access: access([...fullCommonScopes, 'style/workflow']),
  },
  {
    role: 'Marketing',
    access: access([...marketingScopes]),
  },
  {
    role: 'Order',
    access: access([...orderScopes]),
  },
  {
    role: 'SKU-Barcodes',
    access: access([...fullCommonScopes, 'style/workflow']),
  },
  {
    role: 'Supplier Manager',
    access: access([...adminScopes, 'style/workflow', ...supplierScopes]),
  },
];
